(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sky-header-language')) {
    class SkyHeaderLanguage extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const details = this.querySelector('details');
        if (!details) return;
        const options = { signal: this.lifecycle.signal };
        document.addEventListener('pointerdown', event => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !details.open) return;
          details.open = false;
          details.querySelector('summary')?.focus();
          event.preventDefault();
          event.stopPropagation();
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
        }, options);
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
      }
    }
    customElements.define('sky-header-language', SkyHeaderLanguage);
  }

  if (!customElements.get('sky-header-recovery-controller')) {
    class SkyHeaderRecoveryController extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const header = this.closest('header-component');
        if (!header) return;
        const options = { signal: this.lifecycle.signal };
        const closeMenus = () => {
          header.querySelectorAll('.sky-header-recovery__toggle[open], .sky-header-recovery__branch[open]')
            .forEach(details => { details.open = false; });
        };
        header.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const details = event.target.closest('details[open]');
          if (!details?.matches('.sky-header-recovery__toggle, .sky-header-recovery__branch')) return;
          details.open = false;
          details.querySelector(':scope > summary')?.focus();
          event.preventDefault();
          event.stopPropagation();
        }, options);
        header.addEventListener('click', event => {
          if (event.target.closest('.sky-header-recovery__list a')) closeMenus();
        }, options);
        document.addEventListener('pointerdown', event => {
          header.querySelectorAll('.sky-header-recovery__toggle[open], .sky-header-recovery__branch[open]')
            .forEach(details => {
              if (!details.contains(event.target)) details.open = false;
            });
        }, options);
        window.addEventListener('resize', closeMenus, options);
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
      }
    }
    customElements.define('sky-header-recovery-controller', SkyHeaderRecoveryController);
  }

  if (!customElements.get('sky-home-layout')) {
    class SkyHomeLayout extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('header-component');
        if (!this.header) return;
        if (SkyHomeLayout.active && SkyHomeLayout.active !== this) SkyHomeLayout.active.release();
        SkyHomeLayout.active = this;
        this.root = document.documentElement;
        this.lifecycle = new AbortController();
        this.sections = new Set();
        this.needsMeasure = true;
        this.needsRefresh = true;
        this.frame = 0;
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.root.setAttribute('data-sky-home-layout', '');
        const options = { signal: this.lifecycle.signal };
        const refresh = event => {
          // Editor changes may alter the natural width without a viewport resize.
          if (event?.type?.startsWith('shopify:')) this.measuredLayoutKey = null;
          this.schedule(true, true);
        };
        if (!('IntersectionObserver' in window)) {
          document.addEventListener('scroll', () => this.schedule(), { ...options, capture: true, passive: true });
        }
        this.headerStateObserver = new MutationObserver(() => this.schedule());
        this.headerStateObserver.observe(this.header, { attributes: true, attributeFilter: ['data-sticky-state'] });
        window.addEventListener('resize', () => this.schedule(true), options);
        window.addEventListener('pageshow', refresh, options);
        document.addEventListener('DOMContentLoaded', refresh, options);
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']
          .forEach(name => document.addEventListener(name, refresh, options));
        if (document.fonts?.ready) {
          document.fonts.ready.then(() => { if (this.isConnected) this.schedule(true); });
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.schedule());
          this.resizeObserver.observe(this.header);
        }
        this.observer = new MutationObserver(records => {
          const selector = 'sky-meridian-board, .sky-why, .sky-about, .sky-clients, .sky-contact, .sky-footer';
          const relevant = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
          ));
          if (relevant) refresh();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.schedule(true, true);
      }

      schedule(measure = false, refresh = false) {
        this.needsMeasure ||= measure;
        this.needsRefresh ||= refresh;
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.isConnected) return;
          if (this.needsRefresh) {
            this.needsRefresh = false;
            this.refreshSections();
          }
          if (this.needsMeasure) {
            this.needsMeasure = false;
            this.measureCompactHeader();
          }
          this.updateHeader();
          if (!this.readyFrame && !this.header.hasAttribute('data-sky-home-ready')) {
            this.readyFrame = requestAnimationFrame(() => {
              this.readyFrame = requestAnimationFrame(() => {
                this.readyFrame = 0;
                if (this.isConnected) this.header.setAttribute('data-sky-home-ready', '');
              });
            });
          }
        });
      }

      refreshSections() {
        this.board = document.querySelector('sky-meridian-board.sky-board');
        const next = new Set([...document.querySelectorAll('.sky-why, .sky-about, .sky-clients, .sky-contact, .sky-footer')]
          .filter(section => !this.board || Boolean(this.board.compareDocumentPosition(section) & 4)));
        this.sections.forEach(section => {
          if (!next.has(section)) section.removeAttribute('data-sky-home-content');
        });
        next.forEach(section => {
          if (!section.hasAttribute('data-sky-home-content')) section.setAttribute('data-sky-home-content', '');
        });
        this.sections = next;
        this.resizeObserver?.disconnect();
        this.resizeObserver?.observe(this.header);
        if (this.board) this.resizeObserver?.observe(this.board);
      }

      measureCompactHeader() {
        const columns = [...this.header.querySelectorAll(':scope > .header__row > .header__columns')];
        if (!columns.length) return;
        const viewport = this.root.clientWidth || window.innerWidth;
        const boardWidth = this.board?.getBoundingClientRect().width || viewport - 20;
        const layoutKey = `${viewport}|${boardWidth}|${columns.length}`;
        // DOMContentLoaded, pageshow and fonts.ready can all request the same measure.
        if (this.measuredLayoutKey === layoutKey && this.header.hasAttribute('data-sky-home-measured')) return;
        const transitions = columns.map(column => ({
          column,
          value: column.style.getPropertyValue('transition'),
          priority: column.style.getPropertyPriority('transition')
        }));
        columns.forEach(column => column.style.setProperty('transition', 'none', 'important'));
        this.header.setAttribute('data-sky-home-measuring', '');
        const rect = columns.map(column => column.getBoundingClientRect()).find(box => box.width > 0);
        if (rect?.width > 0 && viewport > 0) {
          const compact = Math.min(rect.width, viewport);
          this.measuredLayoutKey = layoutKey;
          const wide = Math.max(compact, Math.min(boardWidth, viewport - 20));
          const compactValue = compact.toFixed(2) + 'px';
          const wideValue = wide.toFixed(2) + 'px';
          if (this.root.style.getPropertyValue('--sky-home-content-width') !== compactValue)
            this.root.style.setProperty('--sky-home-content-width', compactValue);
          if (this.root.style.getPropertyValue('--sky-home-wide-width') !== wideValue)
            this.root.style.setProperty('--sky-home-wide-width', wideValue);
          this.header.setAttribute('data-sky-home-measured', '');
        }
        this.header.removeAttribute('data-sky-home-measuring');
        // Încheie măsurarea fără să afișeze o îngustare intermediară la resize.
        if (this.header.hasAttribute('data-sky-home-ready')) columns[0].getBoundingClientRect();
        transitions.forEach(({ column, value, priority }) => {
          if (value) column.style.setProperty('transition', value, priority);
          else column.style.removeProperty('transition');
        });
      }

      updateHeader() {
        if (!this.desktop.matches || !this.board?.isConnected) {
          this.boardObserver?.disconnect();
          this.boardObserver = null;
          this.boundaryKey = '';
          this.header.removeAttribute('data-sky-home-wide');
          return;
        }
        const boundary = Math.max(0, this.header.getBoundingClientRect().bottom);
        const height = this.root.clientHeight || window.innerHeight;
        const key = `${boundary.toFixed(1)}|${height}`;
        if (this.observedBoard === this.board && this.boundaryKey === key && this.boardObserver) return;
        const board = this.board.getBoundingClientRect();
        const wide = board.width > 0 && board.height > 0 && board.top <= boundary + 48 && board.bottom > boundary + 16;
        this.header.toggleAttribute('data-sky-home-wide', wide);
        if (!('IntersectionObserver' in window)) return;
        this.boardObserver?.disconnect();
        this.observedBoard = this.board;
        this.boundaryKey = key;
        this.boardObserver = new IntersectionObserver(entries => {
          if (!this.isConnected || !this.desktop.matches) return;
          const entry = entries[entries.length - 1];
          const active = entry.isIntersecting && entry.boundingClientRect.width > 0 && entry.boundingClientRect.height > 0;
          if (this.header.hasAttribute('data-sky-home-wide') !== active) this.header.toggleAttribute('data-sky-home-wide', active);
        }, { rootMargin: `${-(boundary + 16)}px 0px ${boundary + 48 - height}px 0px`, threshold: 0 });
        this.boardObserver.observe(this.board);
      }

      disconnectedCallback() {
        this.release();
      }

      release() {
        this.lifecycle?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.boardObserver?.disconnect();
        this.headerStateObserver?.disconnect();
        this.boardObserver = null;
        this.observedBoard = null;
        this.boundaryKey = '';
        cancelAnimationFrame(this.readyFrame);
        this.readyFrame = 0;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        if (SkyHomeLayout.active !== this) return;
        this.sections?.forEach(section => section.removeAttribute('data-sky-home-content'));
        this.header?.removeAttribute('data-sky-home-wide');
        this.header?.removeAttribute('data-sky-home-measured');
        this.header?.removeAttribute('data-sky-home-ready');
        this.header?.removeAttribute('data-sky-home-measuring');
        this.measuredLayoutKey = null;
        this.root?.removeAttribute('data-sky-home-layout');
        this.root?.style.removeProperty('--sky-home-content-width');
        this.root?.style.removeProperty('--sky-home-wide-width');
        SkyHomeLayout.active = null;
      }
    }
    customElements.define('sky-home-layout', SkyHomeLayout);
  }

  if (!customElements.get('sky-mobile-label-layout')) {
    class SkyMobileLabelLayout extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.mobile = matchMedia('(max-width: 749px)');
        this.labels = new Set();
        this.selector = '.sky-legend-button__text, .sky-why__heading';
        const options = { signal: this.events.signal };
        const queue = event => {
          if (event?.type === 'loadingdone' || event?.type === 'shopify:section:load') this.labelFitKey = null;
          this.queue();
        };
        this.mobile.addEventListener('change', queue, options);
        window.addEventListener('resize', queue, options);
        document.addEventListener('DOMContentLoaded', queue, { ...options, once: true });
        document.addEventListener('shopify:section:load', queue, options);
        document.fonts?.addEventListener('loadingdone', queue, options);
        document.fonts?.ready.then(() => { if (this.isConnected) { this.labelFitKey = null; this.queue(); } });
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(entries => {
            const width = entries[0]?.contentRect.width;
            if (width !== this.width) { this.width = width; this.queue(); }
          });
          this.resize.observe(document.documentElement);
        }
        this.mutations = new MutationObserver(records => {
          if (records.some(record =>
            record.target.parentElement?.closest(this.selector) ||
            record.target.closest?.(this.selector) ||
            Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
              (node.matches(this.selector) || node.querySelector(this.selector)))
          )) this.queue();
        });
        this.mutations.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
        this.queue();
      }

      queue() {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.fit();
        });
      }

      fit() {
        const labels = [...document.querySelectorAll(this.selector)];
        const key = [window.innerWidth, window.innerHeight, window.devicePixelRatio, this.mobile.matches,
          document.fonts?.status, ...labels.map(label => label.textContent)].join('|');
        if (key === this.labelFitKey && labels.length === this.labels.size && labels.every(label => this.labels.has(label))) return;
        this.labelFitKey = key;
        const reset = new Set([...this.labels, ...labels]);
        reset.forEach(label => {
          if (label.style.getPropertyValue('--sky-mobile-fit-width')) label.style.removeProperty('--sky-mobile-fit-width');
        });
        this.labels = new Set(labels);
        if (!this.mobile.matches) return;
        const range = document.createRange();
        const widths = [];
        this.labels.forEach(label => {
          const text = label.querySelector('strong') || label;
          const available = label.getBoundingClientRect().width;
          if (!available || !text.textContent.trim()) return;
          range.selectNodeContents(text);
          const lines = Array.from(range.getClientRects(), rect => rect.width);
          const width = Math.ceil(Math.max(0, ...lines));
          if (width > 0 && width < available - .5) widths.push([label, width]);
        });
        widths.forEach(([label, width]) => label.style.setProperty('--sky-mobile-fit-width', `${width}px`));
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        this.mutations?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.labels?.forEach(label => label.style.removeProperty('--sky-mobile-fit-width'));
      }
    }
    customElements.define('sky-mobile-label-layout', SkyMobileLabelLayout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
